import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "./Logo";

const links = [
  { label: "Home", to: "/" },
  { label: "Field Notes", to: "/field-notes" },
  { label: "Our Approach", to: "/our-approach" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <header
      data-testid="global-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-midnight/95 backdrop-blur-md shadow-lg shadow-black/30" : "bg-midnight"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 sm:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" aria-label="SymbiCognitive home">
          <Logo imgClassName="h-16 sm:h-[68px] w-auto" />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`text-sm transition-colors duration-200 ${
                pathname === l.to ? "text-amber" : "text-slate-300 hover:text-amber"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/field-notes"
            data-testid="nav-cta"
            className="bg-amber text-midnight font-semibold text-sm px-5 py-2.5 rounded-full glow-amber"
          >
            Read the Field Notes
          </Link>
        </div>

        <button
          className="md:hidden text-slate-200"
          onClick={() => setOpen((o) => !o)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            {open ? <path d="M18 6 6 18M6 6l12 12" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
          </svg>
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-midnight border-t border-white/10 px-6 py-4 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-left text-slate-200 hover:text-amber transition-colors"
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/field-notes"
            className="bg-amber text-midnight font-semibold px-5 py-2.5 rounded-full mt-1 text-center"
            data-testid="nav-mobile-cta"
          >
            Read the Field Notes
          </Link>
        </div>
      )}
    </header>
  );
};

export default Navbar;
